// lodash
import get from 'lodash/get';
import isString from 'lodash/isString';
import { push, goBack } from 'connected-react-router';
import { updateBillingAddress } from './cardPaymentActions';
import { initPaymentPage } from './orderFormActions';
import {
  URL_GET_PACT_PAYMENT_DATA,
  URL_PACT_CARD_PAYMENT,
} from '../../../constants/endpointConstants';
import {
  PACT_PAYMENT_CANCEL,
  PACT_PAYMENT_ERROR,
  PACT_PAYMENT_SUCCESS,
  PACT_PAYMENT_INIT,
  GET_PACT_PAYMENT_DATA,
  UPDATE_BILLING_ADDRESS,
  PACT_CARD_PAYMENT,
} from '../../../constants/actionConstants';
import { getBillingAddress } from '../../../utils/address/addressHelpers';
import handleReserveStock, { revertStockReservation } from './handleReserveStock';
import errorCodeConstants from '../../../constants/errorCodeConstants';
import routeConstants from '../../../constants/routeConstants';
import getPathWithQueryString from '../../../utils/helpers/url';
import queryStrings from '../../../constants/queryStringConstants';
import { submitOrderAndRedirect } from './submitOrderActions';
import { isPactApp } from '../../reducers/app/appReducer';

function parseData(json) {
  if (isString(json)) {
    return JSON.parse(json);
  }
  return json;
}

export const paymentPactInit = ({
  amountOverride,
  state,
  retry,
}) => async (dispatch) => {

  if (!retry) {
    const billingAddress = getBillingAddress(state);

    if (billingAddress) {
      const { type } = await dispatch(updateBillingAddress(billingAddress));
      if (type === `${UPDATE_BILLING_ADDRESS}.FAILED`) {
        return;
      }
    }

    const reserveStockResponse = await dispatch(handleReserveStock());
    if (reserveStockResponse.type.includes('FAILED')) return;

    // show PACT Modal
    await dispatch(push(routeConstants.PAYMENT_PACT));
  }

  dispatch({ type: PACT_PAYMENT_INIT });

  const getPactPaymentDataResponse = await dispatch({
    type: GET_PACT_PAYMENT_DATA,
    request: client => client({ path: URL_GET_PACT_PAYMENT_DATA, config: { method: 'GET' } }),
  });

  const { type, result } = getPactPaymentDataResponse;

  if (type === `${GET_PACT_PAYMENT_DATA}.SUCCESS`) {

    const {
      amount,
      omsOrderId,
      currency,
      transactionDate,
    } = result;

    const initData = {
      amount: amountOverride || amount,
      currency,
      omsOrderId,
      transactionDate,
    };

    try {
      window.webkit.messageHandlers.callbackHandler.postMessage(initData);
      return;
    } catch (err) {
      // eslint-disable-next-line no-console
      console.warn('Error: callbackHandler.postMessage()', err);
    }
  }

  const error = {
    code: '000',
    title: 'An unknown error occurred trying to connect to the card reader',
    body: 'Please restart the Partner App and try again',
    actions: undefined,
  };

  // show cross and message on PACT Modal
  setTimeout(() => {
    dispatch({
      type: PACT_PAYMENT_ERROR,
      payload: error,
    });
  }, 1000);

};

export const paymentPactSuccess = paymentData => async (dispatch) => {
  const payload = parseData(paymentData);

  // show tick and message on PACT Modal
  dispatch({
    type: PACT_PAYMENT_SUCCESS,
    payload,
  });
};

export const paymentPactCancel = (doBack = true) => (dispatch, getState) => {
  const state = getState();

  // only cancel payment if the modal is open
  // OR if the modal is not open but user is on payment page (has navigated via browser)
  if (state.payment.pactPaymentModalOpen ||
    (!state.payment.pactPaymentModalOpen && state.router.location.pathname === routeConstants.PAYMENT)) {
    // reset PACT Modal
    dispatch({
      type: PACT_PAYMENT_CANCEL,
    });

    dispatch(revertStockReservation());
    if (doBack) { dispatch(goBack()); }
    dispatch(initPaymentPage());
  }
};

export const paymentPactError = (error = {}) => async (dispatch) => {
  const payload = parseData(error);

  // show cross and error message on PACT Modal
  dispatch({
    type: PACT_PAYMENT_ERROR,
    payload,
  });
};

export const submitAndHandlePactPayment = () => async (dispatch, getState) => {

  const {
    pedId,
    cardToken,
    cardExpiryDate,
    authorisationNumber,
    obfuscatedPAN,
    amountApproved,
    transactionDate,
    paymentCaptureMethod,
  } = get(getState(), 'payment.pactPaymentPedResponseData');

  const retailTransactionId = `${get(getState(), 'payment.pactPaymentInitData.transactionDate', '')}`;

  const body = {
    pedId,
    cardToken,
    cardExpiryDate,
    authorisationNumber,
    obfuscatedPAN,
    amountApproved,
    transactionDate,
    paymentCaptureMethod,
    retailTransactionId,
  };

  const submitPactPaymentResponse = await dispatch({
    type: PACT_CARD_PAYMENT,
    request: client => client({ path: URL_PACT_CARD_PAYMENT, config: { method: 'POST', body } }),
    isPactApp: isPactApp(getState()),
  });

  const { type } = submitPactPaymentResponse;

  if (type === `${PACT_CARD_PAYMENT}.FAILED`) {
    const { error: { code } } = submitPactPaymentResponse;
    if (code === errorCodeConstants.SERVER_INTERNAL_ERROR) {
      const path = getPathWithQueryString(routeConstants.PAYMENT, queryStrings.SUBMITTING_ORDER);
      dispatch(push(path));
      return;
    }
  }

  if (type === `${PACT_CARD_PAYMENT}.SUCCESS` || type === `${PACT_CARD_PAYMENT}.FAILED`) {
    dispatch(submitOrderAndRedirect());
  }
};
